import { State } from 'utils/state';

/**
 * UI-only state that is NOT synchronized with the server.
 * Used for local UI concerns like form collapse states, modals, etc.
 */
export interface IUIState {
  /**
   * Whether the VehicleSelectionForm is collapsed to just the burger menu
   */
  vehicleFormCollapsed: boolean;
}

const initialState: IUIState = {
  vehicleFormCollapsed: false,
};

let state: State<IUIState>;

export function uiState() {
  if (!state) {
    state = new State<IUIState>(initialState);
  }
  return state;
}
